/** Labels and support hints for DICOM error categories recorded by the middleware. */
export const DICOM_ERROR_CATEGORIES = {
  association_rejected: {
    label: 'Refused by Orthanc',
    hint: 'Orthanc does not know this AE title, so worklist queries and echoes are refused. Link the machine (or re-sync it to Orthanc if it is already linked).',
  },
  echo_rejected: {
    label: 'Echo refused',
    hint: 'The machine pinged the gateway, but Orthanc refused it because the AE title is not registered.',
  },
  worklist_query_no_match: {
    label: 'Worklists filtered out',
    hint: 'The machine has worklists waiting, but its query filters (date, modality, AE title…) exclude them. Check the console clock and worklist query settings.',
  },
  echo_failed: {
    label: 'Ping failed',
    hint: 'The machine did not answer a C-ECHO. Check it is on, its IP and DICOM port, and that it accepts the NESPLINK AE title.',
  },
  called_ae_rejected: {
    label: 'Wrong called AE',
    hint: 'MPPS was sent to an AE title other than NESPLINK. Update the machine\'s MPPS destination.',
  },
  mixed_mpps_association: {
    label: 'MPPS mixed with images',
    hint: 'MPPS was sent in the same association as other services and was refused. Configure MPPS as its own destination.',
  },
  upstream_unreachable: {
    label: 'Gateway service down',
    hint: 'The DICOM router could not reach Orthanc or the MPPS service. Check the gateway containers.',
  },
  mpps_backend_rejected: {
    label: 'MPPS rejected',
    hint: 'The middleware refused the MPPS, usually because the accession number does not match a request.',
  },
  mpps_unknown_instance: {
    label: 'MPPS update without start',
    hint: 'An MPPS N-SET arrived for a procedure step that was never started here (N-CREATE missing or sent elsewhere).',
  },
  mpps_invalid_create: {
    label: 'Invalid MPPS start',
    hint: 'An MPPS N-CREATE was refused because its status was missing or not IN PROGRESS.',
  },
  orthanc_dicom_error: {
    label: 'Orthanc DICOM error',
    hint: 'Orthanc logged an error while handling DICOM traffic.',
  },
};

export const DICOM_ERROR_SOURCES = {
  orthanc: 'Orthanc',
  dicom_router: 'DICOM router',
  mpps_scp: 'MPPS service',
  middleware: 'Middleware',
};

export const categoryLabel = (category) => DICOM_ERROR_CATEGORIES[category]?.label || category;
export const categoryHint = (category) => DICOM_ERROR_CATEGORIES[category]?.hint || '';
export const sourceLabel = (source) => DICOM_ERROR_SOURCES[source] || source;
